<template>
  <div>
    <AccordionList
      v-for="(item, index) in $options.computed.accordionItemsPlaceholder"
      :key="`item-${index}`"
    >
      <AccordionItem @click.prevent="onItemOpened(item.$props.rendering.fields.heading)">
        <template #icon> </template>
        <template #summary>
          <sc-text :field="item.$props.rendering.fields.heading" />
        </template>

        <sc-rich-text :field="item.$props.rendering.fields.content" />
      </AccordionItem>
    </AccordionList>
  </div>
</template>

<script>
import { useAccordion, AccordionList, AccordionItem } from 'vue3-rich-accordion';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-vue';
import 'vue3-rich-accordion/accordion-library-styles.css';
import { gtmEvent } from '../utils/analytics';
export default {
  name: 'Accordion',
  components: {
    AccordionList,
    AccordionItem,
    ScText: Text,
    ScRichText: RichText,
  },
  props: {
    rendering: {
      type: Object,
      required: true,
    },
  },
  withPlaceholder() {
    return {
      placeholders: [
        {
          placeholder: 'jss-accordion-items',
          computedPropName: 'accordionItemsPlaceholder',
        },
      ],
    };
  },
  methods: {
    onItemOpened(item) {
      gtmEvent('accordion', {
        item: item.value,
      });
    },
  },
  computed: {
    fields() {
      // rendering.fields are populated from route YAML (disconnected)
      // or from Layout Service (integrated)
      return this.rendering?.fields || {};
    },

    itemsList() {
      // Handle both disconnected (array) and connected (value.value array) modes
      const items = this.fields?.items;
      if (!items) return [];

      // If items has a 'value' property, it's from Layout Service (connected mode)
      if (items.value && Array.isArray(items.value)) {
        return items.value;
      }

      // Otherwise it's disconnected mode (direct array)
      if (Array.isArray(items)) {
        // In disconnected mode, wrap each item to match connected structure
        return items.map((item) => ({ fields: item }));
      }

      return [];
    },
  },
};
</script>
